var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promotion)?_c('div',{staticClass:"coupon elevation-3"},[_c('CouponTop',{attrs:{"promotion":_vm.promotion,"bizs":_vm.bizs,"chains":_vm.chains}}),_c('v-divider'),_c('div',{staticClass:"d-flex flex-row justify-center my-2"},[_c('ClaimBtn',{attrs:{"promotion":_vm.promotion,"promoclaim":_vm.promoclaim}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }